module.exports = __webpack_public_path__ + "static/img/m15.72f6d75.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/spark2/mobile/m15.png
// module id = sQ9X
// module chunks = 12